<template>
  <div class="mx-auto my-2">
    <v-card class="basil">
      <v-card-title>
        Renewal Status Report
        <v-spacer></v-spacer>
      </v-card-title>

      <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tab v-for="tabItem in tabItems" :key="tabItem">
          {{ tabItem }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="tabItem in tabItems" :key="tabItem">
          <div v-if="tabItem == 'Newly Registered'" style="min-height: 100vh">
            <NewlyRegistered></NewlyRegistered>
          </div>
          <div v-if="tabItem == 'Upcoming Renewal'" style="min-height: 100vh">
            <UpcomingRenewal></UpcomingRenewal>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import {getUser} from "@/utils/helper";
import NewlyRegistered from "./NewlyRegistered/newly-registered-report.vue";
import UpcomingRenewal from "./UpcomingRenewal/upcoming-renewal.vue"

export default {
  components: {
    NewlyRegistered,
    UpcomingRenewal
  },
  data() {
    return {
      tab: null,
      tabItems: ["Newly Registered", "Upcoming Renewal"],
    };
  },
  computed: {
    canViewRegistration() {
      return getUser().permissions.some(
          (permission) =>
              permission.menuItem.menuItemName == "Renewal Status Report"
      );
    },
  },
}
</script>

<style scoped>
.basil {
  background-color: #eff6ff !important;
}

.basil--text {
  color: #356859 !important;
}
</style>

